import { useMemo } from 'react';
import { MerklCampaign } from '../other/useMerklDappCampaigns';
import uniq from 'lodash.uniq';

export const useTokenAddresses = (merkl_campaigns: MerklCampaign[]) => {
  return useMemo(() => {
    const addresses = uniq(merkl_campaigns.flatMap((campaign) => [campaign.token_0_address, campaign.token_1_address]));
    return addresses.join(',');
  }, [merkl_campaigns]);
};
